import env from '../config/env';

const redirectToLogin = (): void => {
  const url = env.LOGIN_URL;
  window.location.assign(`${url}?origin=${window.location.href}`);
};

const redirectToDashboard = (): void => {
  window.location.assign(env.SITE_URL);
};

export { redirectToLogin, redirectToDashboard };
